import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import {
	NavigationPropType,
	PromoBlockPropType,
	RubricPropType,
	TextBlockPropType
} from 'propTypes/common';

import { Layout, LayoutBlock } from 'components/Layout';
import Container from 'components/Container';
import MainPromoBlocks from 'components/promoBlocks/MainPromoBlocks';
import Search from 'components/landings/Search';

import CitiesAndRegions from './components/CitiesAndRegions';
import Nature from './components/Nature';
import Catalogs from './components/Catalogs';
import VirtualTours from './components/VirtualTours';
import VacationInRussia from './components/VacationInRussia';

import styles from './styles.module.scss';

const {
	publicRuntimeConfig: { assetPrefix }
} = getConfig();

const VisitTemplate = ({
	menu,
	blocks: {
		citiesAndRegions,
		russianNature,
		virtualTours,
		searchPrompts,
		vacationInRussia,
		incutSimplePromoBlock
	},
	textBlocks,
	counters,
	rubric,
	text,
	topPromoBlock
}) => {
	const {
		citiesAndRegionsText,
		russianNatureText,
		institutesText,
		virtualToursText,
		vacationInRussiaText
	} = textBlocks;

	return (
		<Layout menu={menu} rubric={rubric} topPromoBlock={topPromoBlock}>
			<LayoutBlock>
				<Search
					title="Путешествуем по России"
					images={[
						`${assetPrefix}images/landings/visit_banner_left_part.svg`,
						`${assetPrefix}images/landings/visit_banner_right_part.svg`
					]}
					mainImage="right"
					backgroundMobileSize="small"
					imageClassName={styles.searchImage}
					backgroundImage={`${assetPrefix}images/landings/visit_banner_background.svg`}
					tags={searchPrompts}
					subtitle={text}
				/>
			</LayoutBlock>
			<LayoutBlock>
				<CitiesAndRegions
					entities={citiesAndRegions}
					subtitle={citiesAndRegionsText && citiesAndRegionsText.text}
				/>
			</LayoutBlock>
			{!_.isEmpty(vacationInRussia) && vacationInRussia.length >= 5 && (
				<LayoutBlock theme="light">
					<VacationInRussia
						entities={vacationInRussia}
						subtitle={vacationInRussiaText && vacationInRussiaText.text}
					/>
				</LayoutBlock>
			)}
			<LayoutBlock>
				<Nature
					entities={russianNature}
					subtitle={russianNatureText && russianNatureText.text}
				/>
			</LayoutBlock>
			<LayoutBlock>
				<VirtualTours
					entities={virtualTours}
					subtitle={virtualToursText && virtualToursText.text}
				/>
			</LayoutBlock>
			<LayoutBlock>
				<Catalogs counters={counters} subtitle={institutesText.text} />
			</LayoutBlock>
			{!_.isEmpty(incutSimplePromoBlock) && (
				<LayoutBlock>
					<Container gutter="noMobile">
						<MainPromoBlocks blocks={incutSimplePromoBlock} />
					</Container>
				</LayoutBlock>
			)}
		</Layout>
	);
};

VisitTemplate.propTypes = {
	menu: NavigationPropType.isRequired,
	blocks: PropTypes.shape({
		citiesAndRegions: PropTypes.array.isRequired,
		russianNature: PropTypes.array.isRequired,
		virtualTours: PropTypes.array.isRequired,
		searchPrompts: PropTypes.array.isRequired,
		vacationInRussia: PropTypes.array.isRequired,
		incutSimplePromoBlock: PropTypes.array.isRequired
	}).isRequired,
	textBlocks: PropTypes.shape({
		citiesAndRegionsText: TextBlockPropType.isRequired,
		russianNatureText: TextBlockPropType.isRequired,
		institutesText: TextBlockPropType.isRequired,
		virtualToursText: TextBlockPropType.isRequired,
		vacationInRussiaText: TextBlockPropType.isRequired
	}).isRequired,
	counters: PropTypes.objectOf(PropTypes.number).isRequired,
	rubric: RubricPropType.isRequired,
	text: PropTypes.string,
	topPromoBlock: PromoBlockPropType
};

export default VisitTemplate;
